export const APPOINTMENT_SELECTION = "appointment/setAppointmentSelectionInfo";

export const CALENDAR_SET_DATE = 'calendar/setSelectedDate'
export const CALENDAR_SET_END_PATH = 'calendar.end'
export const CALENDAR_SET_START_PATH = 'calendar.start'
export const APPOINTMENT_SERVICE_END_TIME_PATH = 'appointment/setAppointmentServiceEndTime'
export const APPOINTMENT_SERVICE_START_TIME_PATH = 'appointment/setAppointmentServiceStartTime'
